import api from "./api";

export const fetch = async (username: string): Promise<any> => {
  try {
    const response = await api.get<any>(`/context/by-user/${username}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Invalid data');
    } else if (error.request) {
      throw new Error('No response from server. Please try again.');
    } else {
      throw new Error('Login failed. Please try again.');
    }
  }
};